'use client';

import React from 'react';
import { useSession } from 'next-auth/react';
import { UserIsAdmin } from '@/core/utils';
import { useAuthGuard } from './auth-guard-provider';

export function AuthGuard({ children }: { children: React.ReactNode }) {
    const { data: session, status } = useSession();
    const { config } = useAuthGuard();

    if (status === 'loading') {
        return (
            <div className="flex items-center justify-center h-screen">
                <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-newui-accent"></div>
            </div>
        );
    }

    const isAdmin = session?.user ? UserIsAdmin(session.user) : false;

    if (config.adminOnly && !isAdmin) {
        return (
            <div className="flex items-center justify-center h-screen bg-white px-6">
                <div className="w-full max-w-lg rounded-2xl border border-newui-light bg-newui-white p-8 text-center shadow-sm">
                    <h2 className="text-xl font-semibold text-gray-700">Admin Access Required</h2>
                    <p className="text-gray-500 mt-2">You need administrator privileges to access this page.</p>
                </div>
            </div>
        );
    }

    return <>{children}</>;
}
